import {gql, useQuery} from '@apollo/client';

/** 一级 / 二级业务分类枚举项（与 Kotlin ReviewBizTypeOptionType / ReviewBizSubTypeOptionType 对齐） */
export interface ReviewBizTypeOption {
    code: string;
    displayOrder: number;
}

export const GET_REVIEW_BIZ_TYPE_LIST = gql`
    query GetReviewBizTypeList {
        getReviewBizTypeList {
            code
            displayOrder
        }
    }
`;

export const GET_REVIEW_BIZ_SUB_TYPE_LIST = gql`
    query GetReviewBizSubTypeList($bizType: String!) {
        getReviewBizSubTypeList(bizType: $bizType) {
            code
            displayOrder
        }
    }
`;

interface GetReviewBizTypeListResponse {
    getReviewBizTypeList: ReviewBizTypeOption[];
}

interface GetReviewBizSubTypeListResponse {
    getReviewBizSubTypeList: ReviewBizTypeOption[];
}

/** 一级审核类型枚举（按 displayOrder 升序） */
export const useReviewBizTypes = () => {
    const {data, loading} = useQuery<GetReviewBizTypeListResponse>(GET_REVIEW_BIZ_TYPE_LIST);
    return {
        options: data?.getReviewBizTypeList ?? [],
        loading,
    };
};

/** 二级业务分类枚举（按一级 bizType 路由）；bizType 为空时不查询。
 *  过滤 OTHER —— OTHER 是数据层兜底（未识别类型落库），不作为筛选选项暴露给用户 */
export const useReviewBizSubTypes = (bizType?: string) => {
    const {data, loading} = useQuery<GetReviewBizSubTypeListResponse>(GET_REVIEW_BIZ_SUB_TYPE_LIST, {
        variables: {bizType: bizType ?? ''},
        skip: !bizType,
    });
    return {
        options: (data?.getReviewBizSubTypeList ?? []).filter((opt) => opt.code !== 'OTHER'),
        loading,
    };
};
